import { buildComponent } from '#components'

const HeaderNavMobile = buildComponent({
  name: 'header-nav-mobile',
  onConnected: (component) => {
    const linkEls = component.querySelectorAll('.js-cat-menu-link')

    if (linkEls.length) {
      const toggleMenu = (link: HTMLElement) => {
        if (window.innerWidth >= 900) {
          return
        }

        const menu = link.nextElementSibling as HTMLElement

        if (menu) {
          link.classList.toggle('active')

          if (link.classList.contains('active')) {
            menu.style.maxHeight = `500px`
          } else {
            menu.style.maxHeight = ''
          }
        }
      }

      linkEls.forEach((link) => {
        if (link instanceof HTMLElement) {
          link.addEventListener('click', () => {
            toggleMenu(link)
          })
        }
      })
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'header-nav-mobile': typeof HeaderNavMobile
  }
}
